import {
  ChakraDivider,
  ChakraFlex,
  ChakraHStack,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
  Info,
  User,
} from '@equip.health/ui';

import { PATIENT_HEADER_TOP_LEVEL_ID } from '~/components/maud/patients/profile/patient-header/patientHeaderConstants';
import { PatientHeaderGenderPronounsCard } from '~/components/maud/patients/profile/patient-header/PatientHeaderGenderPronounsCard';
import { NOT_ON_FILE } from '~/lib/constants/patients.constants';

const { label } = EquipUITheme.typography;

const { secondary } = EquipUIFireflyV2Theme.colors;

interface GenderPronounsProps {
  genderOffRecord: string;
  genderOnRecord: string;
  pronounsOffRecord: string[];
  pronounsOnRecord: string[];
}

interface GenderProps {
  genderOffRecord: string;
  genderOnRecord: string;
}

export const popoverTriggerContent = ({
  genderOffRecord,
  genderOnRecord,
}: GenderProps) => (
  <ChakraHStack
    height="auto"
    id={`${PATIENT_HEADER_TOP_LEVEL_ID}__gender-on-off-record`}
  >
    <User fill={secondary[50]} height="12px" width="12px" />
    <ChakraText
      {...label}
      color="neutral.primary"
      id={`${PATIENT_HEADER_TOP_LEVEL_ID}__gender-on-record`}
      width="auto"
    >
      {genderOnRecord || NOT_ON_FILE}
    </ChakraText>
    <ChakraDivider
      colorScheme="rgba(100, 0, 0, 0.1)"
      id={`${PATIENT_HEADER_TOP_LEVEL_ID}__gender-divider`}
      orientation="vertical"
      width="1px"
    />
    <ChakraText
      {...label}
      color="neutral.primary"
      id={`${PATIENT_HEADER_TOP_LEVEL_ID}__gender-off-record`}
      width="auto"
    >
      {genderOffRecord || NOT_ON_FILE}
    </ChakraText>
    <Info height="12px" width="12px" />
  </ChakraHStack>
);

export const popoverBodyContent = ({
  genderOffRecord,
  genderOnRecord,
  pronounsOffRecord,
  pronounsOnRecord,
}: GenderPronounsProps) => (
  <ChakraFlex
    direction="column"
    id={`${PATIENT_HEADER_TOP_LEVEL_ID}__popover-body`}
  >
    <PatientHeaderGenderPronounsCard
      gender={genderOnRecord}
      pronouns={pronounsOnRecord}
      title="On Record"
    />
    <PatientHeaderGenderPronounsCard
      gender={genderOffRecord}
      pronouns={pronounsOffRecord}
      title="Off Record"
    />
  </ChakraFlex>
);
